<template>
  <div class="lsweepshc">
    <component v-bind:is="headerComponent"></component>
    <div class="content row-container">
      <div class="content__aside">
        <component v-bind:is="sidebarComponent"></component>
      </div>
      <div class="content__main">
        <component name="billing-support" v-bind:is="articlesComponent"></component>
      </div>
    </div>
    <component v-bind:is="footerComponent"></component>
  </div>
</template>

<script>
import { getComponent, trackPageView } from '@/utils/common'

export default {
  name: 'using_site',
  created() {
    trackPageView('using_sitename')
  },
  computed: {
    // Getting Component Dynamically & Asynchronously

    headerComponent() {
      return getComponent(this.$store.getters.flowObject, 'header')
    },
    sidebarComponent() {
      return getComponent(this.$store.getters.flowObject, 'sidebar')
    },
    articlesComponent() {
      return getComponent(this.$store.getters.flowObject, 'articles')
    },
    footerComponent() {
      return getComponent(this.$store.getters.flowObject, 'footer')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/lsweepshc-design.scss';

</style>
